import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../context/AuthContext';
import { navItemsForUser } from '../config/nav';

// Role-aware application shell: brand + top nav + user chip / logout.
export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  if (!user) return <>{children}</>;

  const items = navItemsForUser(user);

  return (
    <div className="App">
      <header className="appshell-header">
        <div className="appshell-inner">
          <Link to={user.district === 'sundargarh' ? '/sundargarh-hub' : '/'} className="appshell-brand">
            <AssessmentIcon /> Survey Dashboard
          </Link>
          <nav className="appshell-nav">
            {items.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                >
                  <Icon /> {item.label}
                </NavLink>
              );
            })}
            <span className="user-chip">
              <AccountCircleIcon fontSize="small" />
              {user.name || user.username}
              <span className="role-badge">{user.role}</span>
            </span>
            <button className="logout-btn" onClick={logout}>
              <LogoutIcon fontSize="small" /> Logout
            </button>
          </nav>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
